import { DateTime, DurationUnit } from 'luxon';

// This function has no unit test because i cannot find how to test a function callback.
// If someone understands this one day, please add a test. - Emile P, 24-11-2020
/**
 * Executes a function after a period of inactivity
 * @param {Function} callback the function to be executed after the timer
 * @param {Number} delay the time in ms before logging out (defaults to 1 hr, 3600000 ms)
 * @returns {Function} the logout function executes after the last timer reset
 */
export const inactivityTime = (callback: () => any, delay = 3600000) => {
  let time: any;
  const resetTimer = () => {
    clearTimeout(time);
    time = setTimeout(callback, delay);
  };
  window.onload = resetTimer;

  // Detect a user interaction
  document.onmousemove = resetTimer;
  document.onkeypress = resetTimer;

  return time;
};

export const toHHMMSS = (seconds: number) => {
  const array: any = [3600, 60];
  return array
    .reduceRight(
      (p: any, b: number) => (r: number) => [Math.floor(r / b)].concat(p(r % b)),
      (r: number) => [r]
    )(seconds)
    .map((a: number) => a.toString().padStart(2, '0'))
    .join(':');
};

export const toSeconds = (string: string) => {
  const arr = string.split(':');
  return Number(arr[0]) * 3600 + Number(arr[1]) * 60 + +Number(arr[2]);
};

/**
 * Set the beginning time of a date and end time of a date (24h)
 * @param {string}  date    get the date
 * @param {boolean} endDate If date added is the end
 */
export const setTimeToDate = (date: any, endDate = false) => {
  const newDate = new Date(date);
  if (endDate) {
    newDate.setHours(23, 59, 59, 999);
  } else {
    newDate.setHours(0, 0, 0, 0);
  }

  return newDate;
};

export const afterToday = (value: Date, period: DurationUnit) => {
  if (DateTime.fromJSDate(value).endOf(period).valueOf() < DateTime.now().valueOf()) {
    return DateTime.fromJSDate(value).endOf(period);
  } else {
    return DateTime.now();
  }
};

export const formatRecurrence = (recurrence: string, locale: string, separator: string) => {
  const [period, time] = (recurrence ?? '').split(' ' + separator + ' ');
  const parsedTime = DateTime.fromFormat(time?.trim() ?? '', 'T');
  if (!parsedTime.isValid) return recurrence ?? '';
  return `${period} ${separator} ${parsedTime.setLocale(locale).toLocaleString(DateTime.TIME_SIMPLE)}`;
};

export const formatTimeTo12Hour = (time24: string, locale: string): string => {
  if (!time24) return '';
  const [hours, minutes] = time24.split(':').map(Number);
  return DateTime.now()
    .set({ hour: hours, minute: minutes })
    .setLocale(locale)
    .toLocaleString(DateTime.TIME_SIMPLE);
};
